import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { FAQModel, FAQResponse } from 'src/app/modules/shared/models/faq.model';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { DynamicMetaService } from 'src/app/modules/shared/services/dynamic-meta.service';
import { KingClubAssets } from '../../enum/icons';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state(
        'void',
        style({
          height: '0px',
          overflow: 'hidden',
          opacity: 0,
        })
      ),
      state(
        'collapsed',
        style({ height: '0', overflow: 'hidden', opacity: 0 })
      ),
      state('expanded', style({ height: '*', overflow: 'hidden', opacity: 1 })),
      transition('collapsed <=> expanded', animate('200ms ease-out')),
    ]),
  ],
})
export class FaqComponent implements OnChanges, OnDestroy {
  @Input() model?: FAQModel;
  @Input() objectId?: any;
  @Input() isStaticPage: boolean = false;

  FAQData: FAQResponse;
  col1 = [];
  col2 = [];
  expandedFaqIndex = -1;

  kingAseets = KingClubAssets;
  constructor(
    private panelService: PanelService,
    private dynamicMetaService: DynamicMetaService
  ) {}

  ngOnChanges(): void {
    this.getFAQData();
  }

  private getFAQData() {
    this.panelService
      .getFAQDetail(this.model, this.objectId)
      .subscribe((result) => {
        this.FAQData = result.find(
          (res) => res.content_type_detail.model === this.model
        );
        this.FAQData.faq_items_detail.map((item) => {
          item['isExpanded'] = false;
        });
        if (this.model === 'homepage') {
          let items = Math.ceil(this.FAQData.faq_items_detail.length / 2);
          this.col1 = [...this.FAQData.faq_items_detail.slice(0, items)];
          this.col2 = [...this.FAQData.faq_items_detail.slice(items)];
        }

        this.loadMetaData();
      });
  }

  private loadMetaData() {
    if (!this.FAQData?.javascript_metadata) return;
    let generatedMeta = this.dynamicMetaService.loadMeta(
      this.FAQData?.javascript_metadata
    );
    this.FAQData['javascript_metadata'] = generatedMeta;
  }

  private unLoadMetaData() {
    if (!this.FAQData?.javascript_metadata) return;
    this.dynamicMetaService.unLoadMeta(this.FAQData?.javascript_metadata);
  }

  ngOnDestroy() {
    this.unLoadMetaData();
  }

  toggleFaq(event: Event, index: number) {
    event.preventDefault();
    if (this.expandedFaqIndex === index) {
      this.expandedFaqIndex = -1;
    } else {
      this.expandedFaqIndex = index;
    }
  }
}
